.overview {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
}

.pressReleaseRoot {
  @container press-release-root (min-width: 1024px) {
    align-items: start;
    width: 358px;
  }
}

.screen {
  @media screen and (width >= 1024px) {
    align-items: start;
    width: 358px;
  }
}
